<div class="background-primary">
    <div *ngIf="parking" class="container listing-wrapper">
        <div class="row">
            <div class="col-md-7 parking-image-container">
                <div class="listing-container">
                    <!-- ================================================================ -->
                    <!--                Image carousel           -->
                    <!-- ================================================================ -->
                    <div *ngIf="!showMobileMap" class="mb-3 position-relative">
                        <carousel (activeSlideChange)="activeSlideChange($event)" *ngIf="images.length > 0" [class]="'gallery-carousel'">
                            <slide *ngFor="let image of images; let i = index">
                                <img *ngIf="i <= highestIndex" [src]="image.smallUrl" alt="" class="w-100" />
                            </slide>
                        </carousel>
                        <div class="no-image-icon">
                            <i class="fa fa-image"></i>
                        </div>
                        <img class="w-100" src="/assets/images/parking/no_image.png" />
                        <div class="image-counter">
                            <small
                                ><strong>{{ currentImageIndex }} / {{ images.length }}</strong></small
                            >
                        </div>
                        <div (click)="toggleMobileMapView()" class="toggle-map-button d-md-none"><i class="fas fa-map-marker-alt"></i> Map</div>
                    </div>
                    <div *ngIf="showMobileMap" class="mb-3 position-relative">
                        <app-google-map [mapHeight]="'200px'" [parking]="parking" [zoom]="15"></app-google-map>
                        <div (click)="toggleMobileMapView()" class="toggle-map-button"><i class="fas fa-image"></i> Gallery</div>
                    </div>

                    <!-- ================================================================ -->
                    <!--                Mobile pricing Sub Header           -->
                    <!-- ================================================================ -->
                    <div class="mobile-price-container d-md-none">
                        <!-- ================================================================ -->
                        <!--                Mobile Header           -->
                        <!-- ================================================================ -->
                        <div class="">
                            <h3 class="">{{ parking.title }}</h3>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <div class="address-container">
                                    <div class="address">
                                        {{ parking.parkingLocation.fullAddress }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-4 ps-0">
                                <div class="price-block">
                                    <ng-container *ngIf="parking.plans && parking.plans.length > 0">
                                        <ng-container *ngFor="let plan of parking.plans">
                                            <div *ngIf="plan && plan.feeInCents" class="">
                                                R {{ plan.feeInCents | formatCents }}
                                                <span class="lighter">{{ plan.term | parkingPlanTerm }}</span>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ================================================================ -->
                    <!--                Pricing Details - Desktop           -->
                    <!-- ================================================================ -->
                    <div class="parking-form-header px-4 d-none d-md-block">
                        <div class="row">
                            <div class="col-7">
                                <h3 *ngIf="parking.title">{{ parking.title }}</h3>
                                <h3 *ngIf="!parking.title">Unnamed Parking</h3>
                                <h6 *ngIf="parking.parkingLocationName" class="card-subtitle mb-2 text-info">{{ parking.parkingLocationName }}</h6>
                                <h6 *ngIf="parking.parkingLocation && !parking.parkingLocationName" class="card-subtitle mb-2 text-info">
                                    {{ parking.parkingLocation.city }} <span *ngIf="parking.parkingLocation.suburb"> • {{ parking.parkingLocation.suburb }}</span>
                                </h6>
                            </div>

                            <div class="col-5">
                                <div *ngIf="parking.admytLpr">
                                    <a data-bs-target="#admytModal" data-bs-toggle="modal">
                                        <img alt="" class="float-end" src="assets/images/parking/admyt-lpr.png" />
                                    </a>
                                </div>
                                <div *ngIf="parking.admytQr">
                                    <a data-bs-target="#admytModal" data-bs-toggle="modal">
                                        <img alt="" class="float-end" src="assets/images/parking/admyt-qr.png" />
                                    </a>
                                </div>
                            </div>

                            <div class="row mt-3">
                                <div class="col-12">
                                    <ng-container *ngIf="parking.plans && parking.plans.length > 0">
                                        <ng-container *ngFor="let plan of parking.plans">
                                            <div *ngIf="plan && plan.feeInCents" class="">
                                                <span class="mb-0 price">R {{ plan.feeInCents | formatCents }}</span
                                                >&nbsp;
                                                <span class="mt-2">{{ plan.term | parkingPlanTerm }}</span>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </div>
                        </div>

                        <div class="row my-3">
                            <div class="col-12">
                                <div class="divider"></div>
                            </div>
                        </div>

                        <ng-container *ngIf="parking.parkingAmenities">
                            <ng-container *ngFor="let amenity of parking.parkingAmenities">
                                <div *ngIf="amenity.value" [amenities]="parking.parkingAmenities" [key]="amenity.key" amenity class="button-amenity">
                                    <img [src]="'/assets/icons/amenities/' + amenity.key + '.png'" class="custom-icon" />
                                    {{ typeSpecificAmenities[amenity.key] }}
                                </div>
                            </ng-container>
                            <div class="mt-3">
                                <p>{{ parking.description }}</p>
                                <p>
                                    Please note: The parking owner does not have the resources to action parking requests outside of weekly working hours (incl. weekends/public holidays).
                                    <ng-container *ngIf="parking && parking.usePolicyUrl">
                                        Kindly remember that all parking is subject to the Landlord's
                                        <a class="text-info text-decoration-underline" href="{{ parking.usePolicyUrl }}" target="_blank">Parking Use Policy and Terms</a>.
                                    </ng-container>
                                    Parking is at your own risk.
                                </p>
                            </div>
                        </ng-container>

                        <div class="row my-3">
                            <div class="col-12">
                                <div class="divider"></div>
                            </div>
                        </div>

                        <div *ngIf="parking && parking.parkingLocation" class="row mt-4 d-none d-md-block">
                            <div class="col-12">
                                <div class="map-container">
                                    <app-google-map [mapHeight]="'200px'" [parking]="parking" [zoom]="15"></app-google-map>
                                </div>
                                <div class="text-center my-3">
                                    <a href="https://maps.google.com/?q={{ parking.parkingLocation.latitude }},{{ parking.parkingLocation.longitude }}" target="_blank">
                                        {{ parking.parkingLocation.fullAddress }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-5 sidebar pb-3">
                <!-- ================================================================ -->
                <!--                About ParkUpp           -->
                <!-- ================================================================ -->
                <div [ngClass]="{ open: aboutThisParking === 'expanded' }" class="gla-accordion-container mt-3 d-md-none">
                    <div (click)="toggleAccordion('aboutThisParking')" class="gla-accordion-header">
                        About this Parking
                        <span [ngClass]="aboutThisParking === 'collapsed' ? 'arrow-down' : 'arrow-up'" class="float-right">&#9660;</span>
                    </div>
                    <div [@slideAnimation]="aboutThisParking" class="gla-accordion-body">
                        <ng-container *ngFor="let amenity of parking.parkingAmenities">
                            <div *ngIf="amenity.value" [amenities]="parking.parkingAmenities" [key]="amenity.key" amenity class="button-amenity">
                                <img [src]="'/assets/icons/amenities/' + amenity.key + '.png'" class="custom-icon" />
                                {{ typeSpecificAmenities[amenity.key] }}
                            </div>
                        </ng-container>
                        <p>{{ parking.description }}</p>
                        <p>
                            Please note: The parking owner does not have the resources to action parking requests outside of weekly working hours (incl. weekends/public holidays).
                            <ng-container *ngIf="parking && parking.usePolicyUrl">
                                Kindly remember that all parking is subject to the Landlord's
                                <a class="text-info text-decoration-underline" href="{{ parking.usePolicyUrl }}" target="_blank">Parking Use Policy and Terms</a>.
                            </ng-container>
                            Parking is at your own risk.
                        </p>
                    </div>
                </div>

                <!-- ================================================================ -->
                <!--                About ParkUpp           -->
                <!-- ================================================================ -->
                <div [ngClass]="{ open: accordionHowItWorksState === 'expanded' }" class="gla-accordion-container mt-3">
                    <div (click)="toggleAccordion('accordionHowItWorksState')" class="gla-accordion-header">
                        How It Works
                        <span [ngClass]="accordionHowItWorksState === 'collapsed' ? 'arrow-down' : 'arrow-up'" class="float-right">&#9660;</span>
                    </div>
                    <div [@slideAnimation]="accordionHowItWorksState" class="gla-accordion-body">
                        <div>
                            <h6 class="accordion-header">Step 1: <a (click)="globalService.redirectToRegister()" class="text-decoration-underline">Create A Profile</a></h6>
                            <div class="accordion-small-text">You need a profile in order to book a bay so that the parking manager knows who you are.</div>
                        </div>
                        <hr />
                        <div>
                            <h6 class="accordion-header">Step 2: Book Your Bay</h6>
                            <div class="accordion-small-text">
                                Fill in how many bays you need and the duration required. Submit your request. Please note, that in the event of your request being accepted, a binding agreement of
                                lease is created for the full duration of your request.
                            </div>
                        </div>
                        <hr />
                        <div>
                            <h6 class="accordion-header">Step 3: Email Confirmation</h6>
                            <div class="accordion-small-text">You'll hear within 24 hours whether your request has been approved via email.</div>
                        </div>
                    </div>
                </div>

                <!-- ================================================================ -->
                <!--                Contact Us           -->
                <!-- ================================================================ -->
                <div [ngClass]="{ open: accordionContactState === 'expanded' }" class="gla-accordion-container mt-3" id="contact-parkupp">
                    <div (click)="toggleAccordion('accordionContactState')" class="gla-accordion-header">
                        Speak To Our Team
                        <span [ngClass]="accordionContactState === 'collapsed' ? 'arrow-down' : 'arrow-up'" class="float-right">&#9660;</span>
                    </div>
                    <div [@slideAnimation]="accordionContactState" class="gla-accordion-body">
                        <p>Our team are ready to help you with any queries!</p>
                        <div>
                            <div class="mb-2"><b class="text-blue">Gauteng Enquiries</b></div>
                            <div>Kwanele Tshabalala</div>
                            <div>E: <a class="" href="mailto:kwanele@parkupp.co.za">kwanele&#64;parkupp.co.za</a></div>
                            <div>T: <a class="" href="tel:+27 71 402 1338">071 402 1338</a></div>
                        </div>
                        <br />
                        <div>
                            <div class="mb-2"><b class="text-blue">Cape Town and Durban Enquiries</b></div>
                            <div>Umar Obaray</div>
                            <div>E: <a class="" href="mailto:umar@parkupp.co.za">umar&#64;parkupp.co.za</a></div>
                            <div>T: <a class="" href="tel:+27 71 280 2308">071 280 2308</a></div>
                        </div>
                        <br />
                        <div>
                            <div class="mb-2"><b class="text-blue">Struggling to pay or don't have a credit card?</b></div>
                            <div>
                                <a (click)="gotoPayFastSpecialLink()" class="">Use PayFast - Alternative Payment Method</a>
                                <div>
                                    <small>
                                        By using PayFast, you will be able to pay with Zapper, SnapScan, Instant EFT, and other payment methods. However, payments must be made manually each month, as
                                        we are not able to debit your account when using PayFast.
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ================================================================ -->
                <!--                Parking Form Block           -->
                <!-- ================================================================ -->
                <div [ngClass]="{ open: accordionBookYourBayState === 'expanded' }" class="gla-accordion-container mt-3">
                    <div (click)="toggleAccordion('accordionBookYourBayState')" class="gla-accordion-header">
                        Book Your Bay
                        <span [ngClass]="accordionBookYourBayState === 'collapsed' ? 'arrow-down' : 'arrow-up'" class="float-right">&#9660;</span>
                    </div>
                    <div [@slideAnimation]="accordionBookYourBayState" class="gla-accordion-body request-card-accordion">
                        <ng-container *ngIf="allowedPaymentType === SubscriptionType.PAYFAST">
                            <app-payfast-booking-form [inputSubscriptionType]="SubscriptionType.PAYFAST" [parking]="parking"></app-payfast-booking-form>
                        </ng-container>
                        <ng-container *ngIf="allowedPaymentType === SubscriptionType.EFT">
                            <app-payfast-booking-form [inputSubscriptionType]="SubscriptionType.EFT" [parking]="parking"></app-payfast-booking-form>
                        </ng-container>
                        <ng-container *ngIf="allowedPaymentType === SubscriptionType.PAYGATE">
                            <!-- ================================================================ -->
                            <!--                Form Warnings          -->
                            <!-- ================================================================ -->
                            <div *ngIf="parking.numberOfBays <= 0 && selectedPlan?.feeInCents">
                                <h4 class="numberOfBays-heading p-3">0 parking spots available</h4>
                            </div>
                            <div *ngIf="!selectedPlan?.feeInCents">
                                <h4 class="numberOfBays-heading p-3">More details coming soon</h4>
                            </div>

                            <ng-container *ngIf="isAuthenticated">
                                <!-- ================================================================ -->
                                <!--                Form           -->
                                <!-- ================================================================ -->
                                <form (ngSubmit)="createSubscription()" *ngIf="parking.numberOfBays > 0 && selectedPlan?.feeInCents" [formGroup]="formData" autocomplete="off" novalidate>
                                    <div class="container-fluid px-0">
                                        <!--                                <div *ngIf="parking.dailySavings" class="row">-->
                                        <!--                                    <div class="col-12">-->
                                        <!--                                        <h5 class="savings">R{{ totalDailySavings | formatCents }} based on daily rate</h5>-->
                                        <!--                                    </div>-->
                                        <!--                                </div>-->
                                        <div class="row d-none d-md-block">
                                            <div *ngIf="parking.plans?.length != 0 && selectedPlan && showPlanSelector" class="form-group text-center col-5">
                                                <select class="form-select" formControlName="planTerm" id="planSelector" name="planTerm">
                                                    <option *ngFor="let plan of parking.plans" [attr.selected]="plan.term == selectedPlan.term ? 'SELECTED' : null" [value]="plan.term">
                                                        {{ plan.term | parkingPlanTerm | titlecase }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="row mt-2">
                                            <div *ngIf="showNumberOfBaysSelected" class="form-group col-6" id="bays-form-group">
                                                <label class="required" for="input-parkingBays">Number of bays</label>
                                                <input class="form-control" formControlName="baysBooked" id="input-parkingBays" min="1" name="baysBooked" type="number" />
                                            </div>

                                            <div *ngIf="showContractDuration" class="form-group col-6">
                                                <label class="required" for="input-contractLength">Duration</label>
                                                <div class="input-group">
                                                    <input class="form-control" formControlName="contractLength" id="input-contractLength" max="12" min="1" name="contractLength" type="number" />
                                                    <div class="input-group-text">
                                                        <span *ngIf="selectedPlan.term == 'MONTHLY'">Months</span>
                                                        <span *ngIf="selectedPlan.term == 'DAILY'">Days</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div *ngIf="showFlexDateSelector" class="row mt-3">
                                            <div class="form-group col-6">
                                                <label for="input-dateFrom">Selected Dates</label>
                                                <select class="form-control" formControlName="flexDateSelector" name="flexDateSelector">
                                                    <option *ngFor="let option of flexDateSelectorOptions" [value]="option.key">
                                                        {{ option.value }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>

                                        <div *ngIf="showStartAndEndDate" class="row mt-3">
                                            <div class="form-group col-6">
                                                <label class="required" for="input-dateFrom">Start Date</label>
                                                <input class="form-control" formControlName="startDate" id="input-dateFrom" name="startDate" type="date" />
                                            </div>

                                            <div (click)="warningDisabledDate()" class="form-group col-6">
                                                <label for="input-parkingBays">End Date</label><span class="muted small"> (automatic)</span>
                                                <input DISABLED class="form-control" formControlName="endDate" id="input-endDate" name="endDate" type="date" />
                                            </div>
                                        </div>

                                        <!--<div class="alert alert-success py-1"
                                     *ngIf="this.formData.value.occupants.length === this.formData.value.baysBooked">
                                    <small>Max vehicles selected</small>
                                </div>-->
                                        <!-- <div *ngIf="showSelectOccupants" class="row mt-3">
                                        <div class="form-group col-12">
                                            <label class="required" for="input-dateFrom">Select Vehicle</label>

                                            <ng-select #dropDownListObject [clearable]="false" [closeOnSelect]="true" [multiple]="true" formControlName="occupants" required>
                                                <ng-template ng-header-tmp>
                                                    <button (click)="openModalOccupant()" class="btn btn-sm btn-primary">Add vehicle</button>
                                                </ng-template>

                                                <ng-option *ngFor="let occupant of occupants" [value]="occupant.$key">{{ occupant.niceName() }}</ng-option>
                                            </ng-select>

                                            <div *ngIf="formData.get('occupants')?.hasError('required') && formData.get('occupants')?.touched" class="invalid-feedback">
                                                Selecting a vehicle is required.
                                            </div>
                                        </div>
                                    </div> -->

                                        <div class="row mt-3">
                                            <div *ngIf="formError" class="form-group col-12 mt-3 alert alert-danger" role="alert">
                                                {{ formError }}
                                            </div>

                                            <!--Change this to show latest parking requests-->
                                            <!--                                <div *ngIf="formSuccess" class="form-group col-12 mt-3 alert alert-success" role="alert">-->
                                            <!--                                    Your parking request has been sent.-->
                                            <!--                                </div>-->

                                            <div class="form-group col-12 mt-1">
                                                <button [disabled]="!formData.valid || formLoading" class="text-white btn bg-blue w-100" type="submit">
                                                    <span *ngIf="formLoading" aria-hidden="true" class="spinner-border spinner-border-sm mr-1" role="status"></span>
                                                    <div class="btn-line-1 text-white">Start Parking Request</div>
                                                    <div class="btn-line-2 text-white">Click here to move to the next step</div>
                                                </button>
                                            </div>

                                            <div class="col-12 mt-2 text-center">
                                                <div class="small text-muted">The parking manager should confirm within 24 hours. This might be affected by weekends or public holidays.</div>
                                            </div>

                                            <div class="mt-3 text-center">
                                                <a (click)="scrollToContact($event)" class="mt-3 py-1 btn btn-outline-blue" href="#contact-parkupp">
                                                    <div class="btn-line-1 text-blue">Prefer to speak to our team?</div>
                                                    <div class="btn-line-2 text-blue">Click here to give us a call</div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </ng-container>
                            <ng-container *ngIf="!isAuthenticated">
                                <div class="mt-3 text-center">
                                    <a (click)="globalService.redirectToRegister()" class="mt-2 text-white btn bg-blue w-100">
                                        <div class="btn-line-1 text-white">Create a ParkUpp Profile</div>
                                        <div class="btn-line-2 text-white">It's completely FREE and takes less than 2 minutes</div>
                                    </a>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <!-- ================================================================ -->
        <!--                Testimonials           -->
        <!-- ================================================================ -->
    </div>

    <div *ngIf="parking" class="container-fluid px-0">
        <div class="row">
            <app-testimonials-block [header]="'What Our Clients Say'"></app-testimonials-block>
        </div>
    </div>
</div>

<!-- ================================================================ -->
<!--                Payment Method Popup           -->
<!-- ================================================================ -->
<app-client-choose-payment-method [openPopup]="openPopup" [parking]="parking" [subscriptionReference]="subscriptionReference"></app-client-choose-payment-method>

<!-- ================================================================ -->
<!--                Admyt Popup           -->
<!-- ================================================================ -->
<div aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal fade" id="admytModal" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">How it Works</h5>
                <button aria-label="Close" class="btn-close" data-bs-dismiss="modal" type="button"></button>
            </div>
            <div class="modal-body p-0">
                <img alt="" class="img-fluid" src="assets/images/parking/admyt-popup.png" />
            </div>
        </div>
    </div>
</div>

<!-- ================================================================ -->
<!--                Popup form           -->
<!-- ================================================================ -->
<ng-template #popupOccupant aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal fade" id="occupantSelectionModal" tabindex="-1">
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">Add a vehicle</h5>
            <button (click)="closeModalOccupant()" aria-label="Close" class="btn-close" data-bs-dismiss="modal" type="button"></button>
        </div>
        <div class="modal-body p-0">
            <div class="container">
                <!--                <div class="alert alert-warning mt-1">You must provide either a driver name or number plate</div>-->

                <form #myForm="ngForm" (ngSubmit)="createOccupant()" [formGroup]="formDataOccupant">
                    <div class="row mt-2">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label class="required">Make and Model</label>
                                <input class="form-control" formControlName="model" name="model" placeholder="City Golf" />
                            </div>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="form-group col-md-12">
                            <label class="required">Number Plate</label>
                            <!--                            <br>-->
                            <!--                            <small>You will need to produce ID if you don't provide vehicle details.</small>-->
                            <input class="form-control" formControlName="numberPlate" name="numberPlate" />
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label class="required">Vehicle Colour</label>
                                <input class="form-control" formControlName="colour" name="colour" placeholder="White" />
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label>Primary Driver Name and Surname</label>
                                <input class="form-control" formControlName="fullName" name="fullName" placeholder="Name and Surname" />
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="form-group col-md-12">
                            <label>Optional description of the car</label>
                            <input class="form-control" formControlName="description" name="description" />
                        </div>
                    </div>
                    <div>
                        <div *ngIf="formError" class="col-12 mt-3">
                            <div class="form-group col-12 mt-3 alert alert-danger small" role="alert">
                                {{ formError }}
                            </div>
                        </div>
                    </div>
                    <div class="row my-5">
                        <div class="form-group col-sm-12">
                            <!--                            <ng-container *ngIf="clientHasCard && !closeOnAdded">-->
                            <!--                                <a class="link-danger float-start mt-2" (click)="toggleForm()">Back to payment-->
                            <!--                                    methods</a>-->
                            <!--                            </ng-container>-->

                            <button [disabled]="!formDataOccupant.valid || formLoadingOccupant == true" class="btn btn-sm btn-primary float-end" type="submit">
                                <span *ngIf="formLoadingOccupant" aria-hidden="true" class="spinner-border spinner-border-sm mr-1" role="status"></span>

                                <i class="mdi mdi-gamepad-circle"></i> Add Vehicle
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</ng-template>
